import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

const AdvancedSearchCountCard = ({ clientKey, clientName, formCount, onClickCallback, isViewingTable }) => <div className="advanced-search-card-count-border p-2 panel">
  <div className="advanced-search-card-count-inner p-2">
    <div className="advanced-search-card-count-results">
      <span className="advanced-search-card-count-client-name" id={ `advanced-search-card-count-client-name_${ clientKey }` }>
        { clientName }</span> - <span id={ `advanced-search-card-count-form-count_${ clientKey }` }>{ formCount }</span> results found.
    </div>
    <div className="advanced-search-card-count-button">
      <button
        id={ `${ isViewingTable ? 'back' : 'view' }-btn_${ clientKey }` }
        type="button"
        className="btn"
        onClick={ () => onClickCallback(clientKey) }
        disabled={ formCount === 0 && !isViewingTable }
      >{ isViewingTable ? 'Back' : 'View' }</button>
    </div>
  </div>
</div>;

AdvancedSearchCountCard.propTypes = {
  clientKey: PropTypes.number.isRequired,
  clientName: PropTypes.string.isRequired,
  formCount: PropTypes.number.isRequired,
  onClickCallback: PropTypes.func.isRequired,
  isViewingTable: PropTypes.bool.isRequired
};

const mapDispatchToProps = dispatch => ({ dispatch });

const ConnectedAdvancedSearchCountCard = connect(
  null,
  mapDispatchToProps
)(AdvancedSearchCountCard);

export default ConnectedAdvancedSearchCountCard;
